var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-item"},[_c('div',{staticClass:"box"},[_vm._t("item_title",function(){return [_vm._v(_vm._s(_vm.title))]},{"qty":_vm.qty,"title":_vm.title,"status":_vm.status})],2),_c('div',{staticClass:"box qty"},[_vm._t("item_qty",function(){return [_vm._v(_vm._s(_vm.qty))]},{"qty":_vm.qty,"title":_vm.title,"status":_vm.status})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }